var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_162_6385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6944 12.5942H14.7988C14.3676 12.5942 14.0176 12.2442 14.0176 11.813C14.0176 11.3817 14.3676 11.0317 14.7988 11.0317H24.6944C25.1256 11.0317 25.4756 11.3817 25.4756 11.813C25.4756 12.2442 25.1256 12.5942 24.6944 12.5942Z",
    fill: "#222222",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7888 16.5001C20.5888 16.5001 20.3889 16.424 20.2367 16.271C19.9315 15.9657 19.9315 15.4709 20.2367 15.1658L23.5908 11.8118L20.2367 8.45764C19.9315 8.15247 19.9315 7.65772 20.2367 7.35255C20.542 7.0472 21.0368 7.0472 21.342 7.35255L25.2481 11.2587C25.5533 11.5638 25.5533 12.0586 25.2481 12.3638L21.342 16.2699C21.1888 16.424 20.9889 16.5001 20.7888 16.5001Z",
    fill: "#222222",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8097 25.8752C8.58674 25.8752 8.37522 25.8439 8.16389 25.7783L1.8952 23.6898C1.04226 23.3919 0.476562 22.5971 0.476562 21.7087V2.95931C0.476562 1.81036 1.41094 0.875977 2.55989 0.875977C2.78267 0.875977 2.99418 0.907256 3.2057 0.972867L9.4742 3.06135C10.3273 3.35927 10.8928 4.15403 10.8928 5.04245V23.7919C10.8928 24.9408 9.95865 25.8752 8.8097 25.8752ZM2.55989 2.43843C2.27342 2.43843 2.03901 2.67283 2.03901 2.95931V21.7087C2.03901 21.9305 2.18797 22.1367 2.40044 22.2107L8.63976 24.2899C8.68458 24.3044 8.74294 24.3127 8.8097 24.3127C9.09617 24.3127 9.33039 24.0783 9.33039 23.7919V5.04245C9.33039 4.82063 9.18143 4.61445 8.96896 4.54045L2.72964 2.46132C2.68482 2.44682 2.62646 2.43843 2.55989 2.43843Z",
    fill: "#222222",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.362 9.20911C15.9308 9.20911 15.5808 8.85912 15.5808 8.42789V3.74053C15.5808 3.02282 14.9966 2.43843 14.2789 2.43843H2.56052C2.12928 2.43843 1.7793 2.08844 1.7793 1.6572C1.7793 1.22596 2.12928 0.875977 2.56052 0.875977H14.2789C15.8591 0.875977 17.1433 2.16034 17.1433 3.74053V8.42789C17.1433 8.85912 16.7933 9.20911 16.362 9.20911Z",
    fill: "#222222",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.278 22.7501H10.1113C9.68007 22.7501 9.33008 22.4001 9.33008 21.9689C9.33008 21.5377 9.68007 21.1877 10.1113 21.1877H14.278C14.9957 21.1877 15.5799 20.6033 15.5799 19.8856V15.1982C15.5799 14.767 15.9299 14.417 16.3611 14.417C16.7923 14.417 17.1423 14.767 17.1423 15.1982V19.8856C17.1423 21.4658 15.8582 22.7501 14.278 22.7501Z",
    fill: "#222222",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_162_6385"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0.476562 0.875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logoutIcon.99175f98ad57654125b503699afa4048.svg";
export { ForwardRef as ReactComponent };